import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useCurrentUserContext } from "providers";
import styles from "./styles.module.scss";
import Log from "../../icons/Logout.svg";
import Settings from "../../icons/settings.svg";
import { ReactComponent as OverviewIcon } from "../../icons/overviewIcon.svg";
import { ConditionalRenderer } from "components/conditonal-renderer";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { ModalCloseIcon } from "icons";
import { ENVIORNMENTS, getCurrentEnviornment } from "utils/constants";

export function Logout({ setVisible }: any) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { saveUserData, user } = useCurrentUserContext();
  const [getData] = UseLazyApiCallV2({
    method: "POST",
    url: "/logout_user",
  }) as any;

  const logoutHandler = async () => {
    Cookies.remove(`${getCurrentEnviornment()}_sessionToken`);
    localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
    localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);

    setIsModalOpen(false);
    if (
      !localStorage.getItem(`${ENVIORNMENTS.LIVE}_userId`) &&
      !localStorage.getItem(`${ENVIORNMENTS.SANDBOX}_userId`)
    ) {
      await getData({
        params: {
          secret_id: user?.secret_id,
        },
      });

      saveUserData(null);
      navigate("/");
      window.location.reload();
    } else {
      sessionStorage.setItem(
        ENVIORNMENTS.ENVIORNMENT,
        `${
          getCurrentEnviornment() === ENVIORNMENTS.LIVE
            ? ENVIORNMENTS.SANDBOX
            : ENVIORNMENTS.LIVE
        }`
      );
      navigate("/m2c-dashboard");
      window.location.reload();
    }

    // window.location.reload();
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSettings = () => {
    setVisible(false);
    navigate("/settings");
  };

  return (
    <>
      <Modal
        className={styles.logoutModal}
        closeIcon={<ModalCloseIcon />}
        title=""
        open={isModalOpen}
        cancelText="No"
        centered={true}
        okText="Yes"
        width={792}
        footer={null}
        onCancel={handleCancel}
      >
        <h1>Confirmation</h1>
        <p>
          Are you sure you want to logout from {getCurrentEnviornment()}{" "}
          account?
        </p>
        <div className={styles["modal-buttons"]}>
          <Button
            className={styles.modalYesButton}
            type="primary"
            onClick={logoutHandler}
          >
            Yes
          </Button>
          <Button className={styles.modalNoButton} onClick={handleCancel}>
            No
          </Button>
        </div>
      </Modal>
      <ConditionalRenderer condition={user?.role === "admin"}>
        <button
          onClick={handleSettings}
          className={styles["logout-back"]}
          style={{ marginBottom: "10px" }}
        >
          <span>
            <img
              src={Settings}
              style={{ marginRight: "5px" }}
              className="log"
              alt="log"
            />
            Settings
          </span>
        </button>
      </ConditionalRenderer>
      {/* <button
        onClick={() => {
          setVisible(false);
          navigate("/analytics");
        }}
        className={styles["logout-back"]}
        style={{ marginBottom: "10px" }}
      >
        <span>
          <OverviewIcon style={{ marginRight: "5px" }} />
          Analytics
        </span>
      </button> */}

      <button onClick={showModal} className={styles["logout-back"]}>
        <span>
          <img
            height={15}
            width={19}
            src={Log}
            style={{ marginRight: "5px" }}
            className="log"
            alt="log"
          />
          Logout
        </span>
      </button>
    </>
  );
}

export default Logout;
